export default {
  dbi_reuse_page_title_key_games: '重点游戏',
  dbi_reuse_page_sub_title_key_games:
    'Data Science团队定义的重点关注休闲手游列表，可通过游戏筛选器更改，更多信息请咨询<a href="mailto:franzzhao@tencent.com">franzzhao@tencent.com</a>',
  dbi_reuse_page_title_arrows_top_charts: '箭头品类榜单',
  dbi_reuse_page_sub_title_arrows_top_charts:
    '默认呈现SensorTower游戏分类为中为箭头的的手游列表。可通过品类筛选器更改。',
  dbi_reuse_page_title_narrative_merge2_top_charts: '剧情二合品类游戏榜单',
  dbi_reuse_page_sub_title_narrative_merge2_top_charts:
    '默认呈现游戏分类为中为剧情二合的手游列表。',
  dbi_reuse_page_title_games_overlap: '超休闲游戏重叠度',
  dbi_reuse_page_sub_title_games_overlap:
    '默认呈现Sensortower产品模型标签为超休闲的手游玩家重叠度，可通过产品模型筛选器更改',
  dbi_reuse_page_title_daily_reports: '休闲游戏日报',
  // Casual Top Charts (SensorTower)
  dbi_reuse_page_title_casual_top_charts_st: '休闲游戏 (SensorTower)',

  // Casual Top Charts (App Magic)
  dbi_reuse_page_title_casual_top_charts_am: '休闲游戏 (App Magic)',

  // Casual Games Store Ranks
  dbi_reuse_page_title_casual_games_store_ranks: '休闲游戏商店排行',
  // Mini-game Rankings
  dbi_reuse_page_title_mini_game_rankings: '小游戏榜单',

  // Mahjong Top Charts
  dbi_reuse_page_title_top_charts_mahjong: '麻将品类榜单',

  // Tab labels (shared)
  dbi_tab_label_casual_hypercasual: '休闲 + 超休闲',
  dbi_tab_label_casual_hyper_hybrid: '休闲 + 超休闲 + 混合休闲',
  dbi_tab_label_hypercasual: '超休闲',
  dbi_tab_label_iaa: 'IAA',
  dbi_tab_label_mahjong_am: '麻将 - App Magic',
  dbi_tab_label_mahjong_st: '麻将 - SensorTower',

  // Tab annotations (SensorTower)
  dbi_tab_annotation_casual_st:
    '默认呈现Sensortower产品模型标签为休闲、超休闲和混合休闲的手游列表，可通过产品模型筛选器更改',
  dbi_tab_annotation_hyper_st: '默认呈现Sensortower产品模型标签为超休闲的手游列表，可通过产品模型筛选器更改',
  dbi_tab_annotation_iaa_st: '默认呈现IAA手游列表，即低游戏内收入的超休闲游戏，可通过产品模型和ARPU筛选器更改',
  dbi_tab_annotation_mahjong_st:
    '默认呈现SensorTower游戏分类为中为麻将的的手游列表。可通过品类、镜头视角、产品模型、主题筛选器更改。可通过品类筛选器更改。',

  // Tab annotations (App Magic)
  dbi_tab_annotation_casual_am: '默认呈现App Magic游戏分类为休闲和超休闲的手游列表，可通过品类筛选器更改',
  dbi_tab_annotation_hyper_am: '默认呈现App Magic游戏分类为超休闲的手游列表，可通过品类筛选器更改',
  dbi_tab_annotation_iaa_am: '默认呈现IAA手游列表，即低游戏内收入的休闲游戏，可通过品类和ARPU筛选器更改',
  dbi_tab_annotation_mahjong_am: '默认呈现App Magic游戏分类为中为麻将的的手游列表。可通过品类筛选器更改。',
};
